module.exports = __webpack_public_path__ + "img/212w.f794933.jpg";